import { Component, forwardRef, Input } from '@angular/core'
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms'
import { FaIconComponent } from '@fortawesome/angular-fontawesome'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { InputType } from '../../types'

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'le-input',
  imports: [FaIconComponent],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => LeInputComponent),
      multi: true,
    },
  ],
  templateUrl: './le-input.component.html',
  styleUrl: './le-input.component.scss',
  standalone: true
})
export class LeInputComponent implements ControlValueAccessor {
  @Input() icon?: IconProp
  @Input() placeholder?: string
  @Input() type: InputType = 'text'
  @Input() disabled = false

  value: any = ''
  onChange: any = () => {}
  onTouched: any = () => {}

  writeValue(value: any): void {
    this.value = value
  }

  registerOnChange(fn: any): void {
    this.onChange = fn
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled
  }

  updateValue(event: Event): void {
    const target = event.target as HTMLInputElement
    this.value = target.value
    this.onChange(this.value)
    this.onTouched()
  }
}
